import request from '../util/SuperagentUtils';

export const loadBuyerTransactions = (buyerId) => {
  return request.get(`/api/buyers/${buyerId}/invoices`);
};

export const loadSupplierTransactions = (supplierId) => {
  return request.get(`/api/suppliers/${supplierId}/transactions`);
};
